export default {
  Incluir: 1,
  Editar: 2,
  Excluir: 3,
  Validar: 4,
  Anexar: 5,
  Visualizar: 6,
};
